(function () {
  'use strict';

  function initBlogCategoryFilter() {
    var container = document.getElementById('categories-multicolumn');
    if (!container) return;

    var currentUrl = window.location.href;
    var isFiltered = currentUrl.indexOf('/tagged/') !== -1;
    var categoryLinks = container.querySelectorAll('.grid-item a, .column__inner a');

    categoryLinks.forEach(function (link) {
      var linkHref = link.getAttribute('href');
      if (!linkHref) return;

      var heading = link.querySelector('.column__heading-small, .column__heading, h2');
      if (!heading) return;

      if (isFiltered) {
        if (linkHref.indexOf('/tagged/') !== -1 && currentUrl.indexOf(linkHref) !== -1) {
          heading.style.setProperty('font-weight', '700', 'important');
        } else {
          heading.style.setProperty('font-weight', '300', 'important');
        }
      } else {
        if (linkHref.indexOf('/tagged/') === -1) {
          heading.style.setProperty('font-weight', '700', 'important');
        } else {
          heading.style.setProperty('font-weight', '300', 'important');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initBlogCategoryFilter);
})();
